! function() {
    "use strict";
    var t = {
            4662: function(t, e, r) {
                r.d(e, {
                    Dz: function() {
                        return n
                    },
                    sg: function() {
                        return a
                    }
                });
                const n = (t = "json") => ({
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: `application/${t}`
                    }
                });

                function a(t, e) {
                    const r = this;
                    let n;
                    return function() {
                        for (var a = arguments.length, o = new Array(a), c = 0; c < a; c++) o[c] = arguments[c];
                        clearTimeout(n), n = setTimeout(function() {
                            return t.apply(r, o)
                        }, e)
                    }
                }
                document.querySelectorAll(".local-scroll").forEach(t => {
                    t.addEventListener("click", t => {
                        t.preventDefault(), t.stopPropagation();
                        const e = t.target.getAttribute("href");
                        ! function(t, e = 0) {
                            const r = document.getElementById("nav-wrapper"),
                                n = document.querySelector(".header").getAttribute("data-ux-position"),
                                a = t.getBoundingClientRect().top;
                            window.scrollTo({
                                top: "off" !== n ? a + window.scrollY - e + parseFloat(r.style.marginTop) : a + window.scrollY - e,
                                behavior: "smooth"
                            })
                        }(document.querySelector(e))
                    })
                })
            }
        },
        e = {};

    function r(n) {
        var a = e[n];
        if (void 0 !== a) return a.exports;
        var o = e[n] = {
            exports: {}
        };
        return t[n](o, o.exports, r), o.exports
    }
    r.d = function(t, e) {
        for (var n in e) r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, {
            enumerable: !0,
            get: e[n]
        })
    }, r.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    };
    var n = r(4662);
    const a = new class {
        constructor() {
            this.items = Array.from(document.querySelectorAll(".cart-item")), this.items.forEach(t => this.manageState(t)), this.selectorsToUpdate = [".cart-summary__header", "#cart-total-price", "#checkout", ".cart-summary__free-shipping"], this.mainCartSelector = ".shopify-section.cart", this.miniCart = document.getElementById("mini-cart"), this.itemsContainersSelector = ".cart-items-container, .cart__empty, .mini-cart--empty", this.parser = new DOMParser
        }
        manageState(t) {
            const e = t.getAttribute("data-variant-id");
            t.querySelector(".cart-item-delete, .cart-item__remove").addEventListener("click", async () => {
                await this.changeCartItem({
                    id: e,
                    quantity: 0
                }), t.remove()
            });
            const r = t.querySelector('input[name="quantity"]');
            if (!r) return;
            const n = t.querySelector('button[name="plus"]'),
                a = t.querySelector('button[name="minus"]'),
                o = t.querySelector('input[name="quantity"]');
            let c = parseInt(r.value);
            n.addEventListener("click", () => {
                c += 1, r.value = c, this.changeCartItem({
                    id: e,
                    quantity: c
                })
            }), a.addEventListener("click", () => {
                c -= 1, r.value = c, this.changeCartItem({
                    id: e,
                    quantity: c
                })
            }), o.addEventListener("change", t => {
                parseInt(t.target.value) > 0 ? (c = parseInt(t.target.value), this.changeCartItem({
                    id: e,
                    quantity: c
                })) : o.value = c
            }), o.addEventListener("keypress", t => {
                (8 !== t.which && 0 !== t.which && t.which < 48 || t.which > 57) && t.preventDefault()
            })
        }
        async changeCartItem(t) {
            const e = {
                ...(0, n.Dz)(),
                body: JSON.stringify({
                    line: +t.id,
                    quantity: t.quantity,
                    sections: "main-cart"
                })
            };
            fetch(`${routes.cartChange}`, e).then(t => t.json()).then(t => {
                const e = e => {
                    const r = this.parser.parseFromString(e, "text/html");
                    if (0 === t.item_count) {
                        const t = document.querySelector(this.mainCartSelector);
                        t && (t.innerHTML = r.querySelector(this.mainCartSelector).innerHTML), this.renderElements(r)
                    } else this.renderItems(r)
                };
                if (t.sections && null !== t.sections["main-cart"]) e(t.sections["main-cart"]);
                else {
                    const t = `${window.location.pathname}?section_id=main-cart`;
                    fetch(t).then(t => t.text()).then(t => {
                        e(t)
                    })
                }
                const r = `${window.location.pathname}?section_id=navigation-main`;
                // fetch(r).then(t => t.text()).then(e => {
                //     const r = this.parser.parseFromString(e, "text/html");
                //     if (0 === t.item_count) {
                //         const t = document.querySelector("#mini-cart");
                //         t && (t.innerHTML = r.querySelector("#mini-cart").innerHTML, t.addEventListeners(), t.querySelectorAll(".icon").forEach(t => t.classList.add("loaded")))
                //     }
                // })
                fetch(r).then(response => response.text()).then(html => {

  const doc = this.parser.parseFromString(html, "text/html");

  const miniCart = document.querySelector("#mini-cart");
  const newMiniCart = doc.querySelector("#mini-cart");

  if (miniCart && newMiniCart) {

    miniCart.innerHTML = newMiniCart.innerHTML;

    if (typeof miniCart.addEventListeners === "function") {
      miniCart.addEventListeners();
    }

    miniCart.querySelectorAll(".icon").forEach(icon => {
      icon.classList.add("loaded");
    });

    document.dispatchEvent(
      new CustomEvent("cart:updated")
    );
  }
})
            }).catch(t => {
                console.error(t)
            })
        }
        renderElements(t) {
            this.selectorsToUpdate.forEach(e => {
                try {
                    const r = document.querySelectorAll(e),
                        n = t.querySelector(e);
                    r.length && n && r.forEach(t => {
                        n.querySelectorAll(".icon").forEach(t => t.classList.add("loaded")), t.replaceWith(n.cloneNode(!0))
                    })
                } catch (t) {
                    console.error(`Error updating ${e}`, t)
                }
            });
            const e = t.querySelector(".cart-count");
            document.querySelectorAll("#cart-open-block .header__icons--cart-open .cart-count").forEach(t => {
                e ? (t.classList.contains("visually-hidden") && t.classList.remove("visually-hidden"), t.textContent = e.textContent) : t.classList.add("visually-hidden")
            }), document.querySelector("#cart-open-block .icon").classList.add("loaded")
        }
        renderItems(t) {
            this.renderElements(t);
            const e = Array.from(document.querySelectorAll(this.itemsContainersSelector)),
                r = t.querySelector(this.itemsContainersSelector);
            e.forEach(t => {
                t && t.replaceWith(r.cloneNode(!0))
            }), document.querySelectorAll(".cart-item").forEach(t => {
                t.querySelectorAll(".icon").forEach(t => t.classList.add("loaded")), this.manageState(t)
            })
        }
        updateMiniCart(t) {
            return fetch("/?section_id=main-cart").then(t => t.text()).then(e => {
                this.renderItems((new DOMParser).parseFromString(e, "text/html")), t && "mini-cart" === cartStrings.uxCart && this.miniCart && this.miniCart.open()
            }).catch(t => {
                console.error("Error updating mini cart:", t)
            })
        }
    };
    window.cartService = a, window.updateMiniCart = (...t) => a.updateMiniCart(...t), customElements.get("cart-note") || customElements.define("cart-note", class extends HTMLElement {
        constructor() {
            super(), this.querySelector("textarea").addEventListener("change", (0, n.sg)(t => {
                const e = JSON.stringify({
                    note: t.target.value
                });
                fetch(`${routes.cartUpdate}`, {
                    ...(0, n.Dz)(),
                    body: e
                })
            }, 300))
        }
    })
}();